module.exports = __webpack_public_path__ + "static/img/solution.97b587e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution.png
// module id = XDrS
// module chunks = 34